import { useState, useEffect, useMemo } from 'react';
import './App.css';
import tileBg from './tile.jpg';
import greyedLogo from './greyedlogo.png';
import bttn1 from './bttn1.jpg';
import bttn2 from './bttn2.jpg';
import bttn3 from './bttn3.jpg';
import bttn4 from './bttn4.jpg';
import gregKirbahue from './gregkirbahue.png';
import s1 from './s1.jpg';
import s2 from './s2.jpg';
import s3 from './s3.jpg';
import s4 from './s4.webp';
import s5 from './s5.jpg';
import s6 from './s6.jpg';
import s7 from './s7.jpg';

const TABS = [
  { id: 'about', label: 'About', img: bttn4 },
  { id: 'videos', label: 'Videos', img: bttn1 },
  { id: 'interesting', label: 'Interesting', img: bttn2 },
  { id: 'forum', label: 'Forum', img: bttn3 },
  { id: 'shop', label: 'Shop', img: bttn1 },
];

function publicAsset(...segments) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const path = `/${segments.join('/')}`.replace(/\/+/g, '/');
  return base ? `${base}${path}` : path;
}

/** Keep in sync with files in public/Videos (used if videos.json is missing). */
const DEFAULT_VIDEO_FILENAMES = [
  '3d_alien_captures_lady.mp4',
  '3d_alien_in_forest.mp4',
  '3d_alien_moon_gang_bang.mp4',
  'alien_and_blue_lady.mp4',
  'alien_area_51.mp4',
  'alien_garage_live_stream.mp4',
  'alien_in_neighborhood.mp4',
  'alien_worm_scene.mp4',
  'swamp_alien.mp4',
  'alien_surpise_gangbang_in_scary_woods.mp4',
  'interplanetary_passion.mp4',
  'lizard_aliens_pleasure_attack.mp4',
];

const VIDEO_DETAILS = {
  '3d_alien_captures_lady.mp4': {
    title: 'Taken Under Starlight',
    previewTime: 120,
    description:
      'She didn\'t run when the light pinned her to the clearing. Rendered in lush 3D, this abduction plays out the way so many of us have fantasized: slow, deliberate, and achingly tender.',
  },
  '3d_alien_in_forest.mp4': {
    title: 'Between the Pines',
    previewTime: 157,
    description:
      'Something ancient and grey stands among the trees, patient as the moss. A lovingly animated encounter set where the treeline meets the cosmos.',
  },
  '3d_alien_moon_gang_bang.mp4': {
    title: 'Selenite Communion',
    previewTime: 92,
    description:
      'Several visitors, one willing soul, and the cold silence of the lunar surface. A zero-gravity ritual of shared flesh that pushes every boundary our planet ever drew.',
  },
  'alien_and_blue_lady.mp4': {
    title: 'Cobalt & Chrome',
    previewTime: 23,
    description:
      'A sapphire-haired woman and her otherworldly companion discover that desire needs no common tongue, only proximity and permission.',
  },
  'alien_area_51.mp4': {
    title: 'Clearance Level: Intimate',
    previewTime: 25,
    description:
      'Somewhere beneath the Nevada desert, behind doors the public will never see, the real testing begins; and the test subjects beg for more.',
  },
  'alien_garage_live_stream.mp4': {
    title: 'Signal Received',
    previewTime: 78,
    description:
      'A shaky webcam, a dim garage, and an audience of twelve true believers watching something unexplainable unfold live. Grainy footage that became legend overnight.',
  },
  'alien_in_neighborhood.mp4': {
    title: 'The House at the End of the Block',
    previewTime: 400,
    description:
      'The curtains are always drawn. The lawn is always perfect. Neighbors who visit come home hours late with faraway eyes and satisfied grins.',
  },
  'alien_worm_scene.mp4': {
    title: 'Bioluminescent Devotion',
    previewTime: 152,
    description:
      'It glows, it writhes, it knows exactly where to go. A pulsing creature born in deep space with one primal instinct, an insatiable need to please.',
  },
  'swamp_alien.mp4': {
    title: 'Bayou Communion',
    previewTime: 32,
    description:
      'It rose from black water on a moonless night, slick and warm and impossibly gentle. Proof that the most otherworldly pleasures can surface in the murkiest of places.',
  },
  'alien_surpise_gangbang_in_scary_woods.mp4': {
    title: 'What Waits Between the Trees',
    previewTime: 480,
    description:
      'A midnight hike goes exactly the way you\'d hope. The clearing was already occupied, and the visitors had been expecting company. Multiple greys, one lucky wanderer, no inhibitions.',
  },
  'interplanetary_passion.mp4': {
    title: 'Orbits Aligned',
    previewTime: 180,
    description:
      'Two bodies drawn together across light-years of empty space. A slow gravitational pull that ends the only way it can: tangled, breathless, and burning like re-entry.',
  },
  'lizard_aliens_pleasure_attack.mp4': {
    title: 'Scaled Affection',
    previewTime: 330,
    description:
      'Cold-blooded only in temperature. A reptilian squad descends with forked tongues and singular focus,proving that the roughest hides can deliver the softest touch.',
  },
};

function humanizeVideoFilename(filename) {
  const stem = filename.replace(/\.[^/.]+$/, '');
  return stem
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

function defaultVideoCopy(filename) {
  const title = humanizeVideoFilename(filename);
  return {
    title,
    description: `Shared for the community that celebrates longing, contact, and intimacy beyond Earth.${title} is here for nights when only the stars understand.`,
  };
}

function buildVideoEntries(filenames) {
  return filenames
    .map((f) => (typeof f === 'string' ? f.trim() : ''))
    .filter(Boolean)
    .map((file, i) => {
      const detail = VIDEO_DETAILS[file] || defaultVideoCopy(file);
      const url = publicAsset('Videos', file);
      const stem = file.replace(/\.[^/.]+$/, '');
      return {
        id: `${file}-${i}`,
        file,
        title: detail.title,
        description: detail.description,
        thumb: publicAsset('Videos', 'thumbs', `${stem}.jpg`),
        link: url,
      };
    });
}

function VideoPreview({ video }) {
  return (
    <div className="video-preview">
      <a href={video.link} target="_blank" rel="noopener noreferrer">
        <div className="video-thumb">
          <img src={video.thumb} alt={video.title} />
          <span className="video-play-overlay" aria-hidden>▶</span>
        </div>
        <div className="video-preview-title">{video.title}</div>
        <p className="video-preview-desc">{video.description}</p>
      </a>
    </div>
  );
}

function VideosPage() {
  const fallback = useMemo(() => buildVideoEntries(DEFAULT_VIDEO_FILENAMES), []);
  const [videos, setVideos] = useState(fallback);

  useEffect(() => {
    let cancelled = false;
    fetch(publicAsset('Videos', 'videos.json'))
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('manifest'))))
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data) ? data : data?.files;
        if (Array.isArray(list) && list.length > 0) {
          setVideos(buildVideoEntries(list));
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <hr className="section-hr" />
      <div className="video-section">
        <div className="video-grid">
          {videos.map((v) => (
            <VideoPreview key={v.id} video={v} />
          ))}
        </div>
      </div>
    </>
  );
}


const INTERESTING_ITEMS = [
  { img: s1, date: 'March 14th, 1993', description: 'I think I heard about this one on the news im pretty sure it crashed somewhere.' },
  { img: s2, date: 'November 7th, 1996', description: 'I dont know.' },
  { img: s3, date: 'May 22nd, 1992', description: 'My buddy told me he took this picture just before he got abducted when he was visiting Neveda for a work trip... curious.' },
  { img: s4, date: 'August 1st, 2001', description: 'My brother thinks this is a stealth bomber, but I think its a flying saucer. Sighted in Utah.' },
  { img: s5, date: 'January 19th, 1998', description: 'I found this while digging through my dads storage closet, not sure what it is but it looks like something alien.' },
  { img: s6, date: 'September 30th, 2004', description: 'I found this image online recently and it looked really cool and like a spaceship kind of. Please discuss.' },
  { img: s7, date: 'December 3rd, 1990', description: 'Sighted in seattle, Washington. Unsure the source of the image, received via email a couple months ago.' },
];

function InterestingPage() {
  return (
    <>
      <hr className="section-hr" />
      <div className="interesting-page">
        <div className="interesting-images">
          {INTERESTING_ITEMS.map((item, i) => (
            <div key={i} className="interesting-frame">
              <img src={item.img} alt={`Interesting ${i + 1}`} className="interesting-img" />
              <p className="interesting-description">{item.description}</p>
              <p className="interesting-date">{item.date}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

const FORUM_POSTS = [
  {
    id: 1,
    title: 'They touched me and I want it again',
    username: 'traumatizedcockring',
    date: 'March 8th, 1993',
    body: 'Ok so this happened two weeks ago and I havent told anyone yet. I was sleeping in my truck out by route 50 in Nevada and I woke up to this humming sound and a bright white light flooding through the windshield. Next thing I know im laying on some kind of table and theres three greys standing over me, one of them puts his hand on my chest real gentle and I swear I felt something I never felt before with any human. They did things to me and all of it felt incredible. When I woke up back in the truck I just cried because I wanted to go back so bad. Has this happened to anyone else?? How do I get them to come back.',
    image: null,
    replies: [
      { username: 'greyedbydemons92', date: 'March 12th, 1993', body: 'Yes. YES. I know exactly what you are talking about. The gentle hand on the chest. God I think about it every single day. I have been leaving my windows open every night hoping they come back for me.' },
      { username: 'xxgregkirbahuexx', date: 'March 14th, 1993', body: 'Welcome to the site friend. You are not alone here, trust me. Stick around.' },
    ],
  },
  {
    id: 2,
    title: 'My alien boyfriend (picture)',
    username: 'cosmiclove',
    date: 'September 22nd, 1994',
    body: 'I drew this based on my memory of him. We met during my abduction in 1991 and he was so beautiful and so tender with me. His eyes were like looking into a black ocean. He held my face in both hands before he did anything else and I swear he was asking permission. I havent been the same since. Im posting this so you all know they are capable of love.',
    image: publicAsset('forum_images', 'alien_boyfriend_picture.jpg'),
    replies: [
      { username: 'traumatizedcockring', date: 'September 25th, 1994', body: 'That is beautiful. He looks exactly like the one who touched me. Maybe they are from the same group??' },
      { username: 'abducteeintraining', date: 'October 1st, 1994', body: 'I want one so bad. You are so lucky cosmiclove.' },
    ],
  },
  {
    id: 3,
    title: 'How to attract them? Serious advice needed',
    username: 'abducteeintraining',
    date: 'January 5th, 1995',
    body: 'Ok I have never been abducted but I want to be SO BAD. I have been sleeping outside every clear night for the past 6 months. I tried flashing lights at the sky, I tried meditating and sending out mental signals, I even tried leaving food out like you would for a stray cat. Nothing is working. Does anyone here have actual advice on how to make contact?? I am desperate and I mean that in the most sincere way. I just want to be held by something not from here.',
    image: null,
    replies: [
      { username: 'greyedbydemons92', date: 'January 8th, 1995', body: 'The food thing wont work lol. From what ive experienced they choose you, you dont choose them. But I do think they can sense when someone is open and willing. Keep your mind focused on them before sleep. Visualize the encounter you want. Be specific.' },
      { username: 'cosmiclove', date: 'January 9th, 1995', body: 'Greyedbydemons92 is right. I was in a deeply vulnerable emotional state when they found me. I think they are drawn to longing. Just keep wanting it and stay open.' },
      { username: 'traumatizedcockring', date: 'January 12th, 1995', body: 'I was just sleeping in my truck so maybe try being somewhere remote and alone. They seem to like it when you are isolated.' },
    ],
  },
  {
    id: 4,
    title: 'UFO cluster sighting and I think they want me',
    username: 'greyalienincubator',
    date: 'June 17th, 1995',
    body: 'I took this photo last week from my back porch in rural New Mexico. There were at least 4 or 5 lights hovering in formation and they stayed for almost 20 minutes. When I walked towards them they got brighter. When I went back inside they dimmed. It felt like they were responding to me. Im going to try going out there again tonight fully naked so they know I am ready and willing. Wish me luck.',
    image: publicAsset('forum_images', 'multiple_ufo_sightings_I_think_they_want_me.jpg'),
    replies: [
      { username: 'abducteeintraining', date: 'June 19th, 1995', body: 'PLEASE update us on this. The naked thing might actually work, they need to know you arent hiding anything.' },
      { username: 'greyedbydemons92', date: 'June 20th, 1995', body: 'The lights responding to your movement is a really good sign. That means they are watching you specifically. Be patient and keep going out there.' },
    ],
  },
  {
    id: 5,
    title: 'Something happened last night by the mill',
    username: 'traumatizedcockring',
    date: 'November 3rd, 1996',
    body: 'I was out by my old mill again and I saw lights in the sky, not like planes but like real actual alien lights. I prayed so hard that they would take me up and use me good but they moved away. Does anyone know how to keep them around when they get close like that? This is the third time theyve come near and left. I feel like they are teasing me. I cant take much more of this.',
    image: null,
    replies: [
      { username: 'cosmiclove', date: 'November 5th, 1996', body: 'Dont give up. Three times means they are interested. They might be studying you from a distance before they make full contact. The teasing is part of it I think.' },
      { username: 'greyalienincubator', date: 'November 8th, 1996', body: 'Have you tried stripping down when you see them? I really do think nudity signals submission and openness. Worth a shot.' },
    ],
  },
  {
    id: 6,
    title: 'Strange alien with hair spotted near my property',
    username: 'greyedbydemons92',
    date: 'April 14th, 1997',
    body: 'Ok this is weird even by our standards. I saw something near my fence line last night and managed to get a picture before it moved away. It looked like a grey but it had HAIR. Like actual hair on its head. Has anyone ever seen anything like this before? Part of me was scared but a bigger part of me was attracted to it. The hair made it feel more approachable somehow. I left my back door open all night after but it didnt come inside.',
    image: publicAsset('forum_images', 'strange_alien_with_hair_encounter.jpg'),
    replies: [
      { username: 'traumatizedcockring', date: 'April 16th, 1997', body: 'What the hell. I have never seen one with hair. Thats kind of hot though not gonna lie.' },
      { username: 'abducteeintraining', date: 'April 18th, 1997', body: 'Maybe its a hybrid? Like half grey half human? That would explain the hair. Either way I would absolutely let it do whatever it wanted to me.' },
      { username: 'xxgregkirbahuexx', date: 'April 20th, 1997', body: 'Interesting photo. Ive never seen anything like that either but there are more varieties of them than most people realize. Thanks for sharing this.' },
    ],
  },
  {
    id: 7,
    title: 'The loneliness is the worst part',
    username: 'cosmiclove',
    date: 'August 29th, 1997',
    body: 'I know we all joke around on here sometimes but can we be real for a minute. The hardest part about all of this is the loneliness. You cant tell anyone in your real life that you are in love with a grey alien. They would lock you up. My family already thinks Im weird. I havent had a human relationship in 3 years because nothing compares. Nothing even comes close. Every night I look at the sky and I just ache. Does anyone else feel like they are just waiting to die so they can finally be with them again. Sorry for the heavy post. I just needed to say it somewhere.',
    image: null,
    replies: [
      { username: 'traumatizedcockring', date: 'September 1st, 1997', body: 'I feel this so deep cosmiclove. You are not alone. We are all waiting together at least.' },
      { username: 'greyedbydemons92', date: 'September 2nd, 1997', body: 'This is exactly why this website matters. Dont apologize for being real. We all feel it.' },
      { username: 'abducteeintraining', date: 'September 4th, 1997', body: 'I havent even been taken yet and I already feel this way. Just knowing what they are capable of makes everything on earth feel empty.' },
    ],
  },
  {
    id: 8,
    title: 'Advice: keeping the connection alive between visits',
    username: 'greyedbydemons92',
    date: 'February 11th, 1998',
    body: 'Ive been experimenting with some techniques to stay connected between abductions and I wanted to share what works for me. First, sleep on your back with your arms at your sides and your palms facing up. This is the position they put you in on the table and it helps your body remember. Second, before sleep think about a specific moment from your encounter. Not the whole thing, just one moment, the more vivid the better. Third, keep something metallic on your nightstand, I use a steel bowl. I dont know why but I feel like they respond to metal. Since I started doing all of this my dreams about them have gotten much more intense and realistic. Twice I woke up with marks.',
    image: null,
    replies: [
      { username: 'cosmiclove', date: 'February 14th, 1998', body: 'The palm up thing works. I started doing that months ago and my dreams changed almost immediately. The metal thing is new to me though, I will try it tonight.' },
      { username: 'greyalienincubator', date: 'February 16th, 1998', body: 'The marks!! I get those too. Small circular bruises on my inner thighs. I always thought I was imagining it but maybe not.' },
    ],
  },
  {
    id: 9,
    title: 'UFO spotted near the bus stop on route 7',
    username: 'abducteeintraining',
    date: 'October 3rd, 1998',
    body: 'I was waiting for the bus home from work and saw this hovering maybe 200 feet above the road. It was just sitting there completely silent. I took this photo but my hands were shaking so bad because I was so excited. I started walking towards it and yelling take me, please take me but it just floated away east. I chased it for about a quarter mile before I lost it. I sat on the curb and cried for 20 minutes. So close.',
    image: publicAsset('forum_images', 'ufo_sighting_near_bus_stop.jpg'),
    replies: [
      { username: 'traumatizedcockring', date: 'October 5th, 1998', body: 'God I know that feeling of watching them leave. It is the worst pain. But hey they showed themselves to you thats a big deal. Keep at it.' },
      { username: 'greyedbydemons92', date: 'October 6th, 1998', body: 'Route 7 where? If this is a hotspot I might drive out there.' },
      { username: 'abducteeintraining', date: 'October 6th, 1998', body: 'Route 7 outside of Cedar City Utah. East side near the old gas station.' },
    ],
  },
  {
    id: 10,
    title: 'Welcome to GREYED',
    username: 'xxgregkirbahuexx',
    date: 'January 1st, 1999',
    body: 'Hey everyone, Greg here. Just wanted to say happy new year and thank you all for keeping this community alive. When I started this site I wasnt sure if anyone else felt the way I do. Turns out a lot of us are out here waiting for the same thing. I dont post much but I read everything and I want you all to know this site isnt going anywhere. As long as Im here this place will be here for you. Keep sharing your stories. They matter. Also I upgraded the server so the forum should be a bit faster now. -Greg',
    image: null,
    replies: [
      { username: 'traumatizedcockring', date: 'January 2nd, 1999', body: 'Thanks Greg. This place is the only reason I dont feel completely insane.' },
      { username: 'cosmiclove', date: 'January 3rd, 1999', body: 'Happy new year Greg. Thank you for building this. You gave us a home.' },
      { username: 'abducteeintraining', date: 'January 3rd, 1999', body: 'Best site on the internet. No question.' },
      { username: 'greyedbydemons92', date: 'January 4th, 1999', body: 'Happy new year everyone. Heres hoping 1999 is the year we all get taken.' },
    ],
  },
  {
    id: 11,
    title: 'Real UFO photo and I think this is the one',
    username: 'greyalienincubator',
    date: 'May 19th, 1999',
    body: 'I finally got a clear photo. Been camping out in the desert for weeks and last night around 2am this thing just appeared out of nowhere. Dead silent, just floating. The underside was glowing this pale blue color and I could feel warmth coming off it even from maybe 100 yards away. I stripped down and laid on the ground arms out palms up like greyedbydemons92 said but nothing happened. It just hovered for about 10 minutes and then shot straight up and was gone. But I FELT something. Like a scanner or a warm wave passing over my whole body. I think they were checking me out. Next time I think they take me.',
    image: publicAsset('forum_images', 'ufo_sighting_real.jpg'),
    replies: [
      { username: 'abducteeintraining', date: 'May 21st, 1999', body: 'The warm wave!! Other people have described that exact thing right before a full abduction. You are so close. Please keep going back to that spot.' },
      { username: 'greyedbydemons92', date: 'May 22nd, 1999', body: 'Glad the palms up technique is spreading. That warm scanning feeling means they are interested in you. Dont wash yourself before you go out next time, I have a theory that they are drawn to natural scent.' },
    ],
  },
  {
    id: 12,
    title: 'Strange dreams lately, getting more intense',
    username: 'greyedbydemons92',
    date: 'July 3rd, 2002',
    body: 'For the past week I keep having the same dream where im on a craft getting probed deep by long grey fingers. Someone is speaking a language I dont recognize but it feels like love. I cant remember the words when I wake up. Ive been working on dream manifestation and lucid dreaming but nothing lets me hold onto it. The dreams keep getting more vivid and more physical though. I woke up sore last Tuesday. Anyone else experiencing escalation like this?',
    image: null,
    replies: [
      { username: 'kennethreid17', date: 'November 20th, 2004', body: 'I had something similar in 98. It stopped after a few months and I never figured out how to keep it going. You should look into reality shifting though, some people have had success with that.' },
      { username: 'abducteeintraining', date: 'July 5th, 2002', body: 'Same here. No one in my life believes me. The soreness is real though, that means something is happening on a physical level.' },
    ],
  },
  {
    id: 13,
    title: 'Blonde aliens?? What are these things',
    username: 'abducteeintraining',
    date: 'March 15th, 2003',
    body: 'Ok so I found this image online and I have no idea what to make of it. These dont look like greys at all. They look almost human but wrong somehow, like too perfect. Blonde hair, pale skin, big eyes. Has anyone encountered these instead of greys? Are they related? Would they also be interested in us the same way?? Im open to anything at this point honestly. I just want contact.',
    image: publicAsset('forum_images', 'what_are_these_strange_alien_concept_blonde_people.jpg'),
    replies: [
      { username: 'greyedbydemons92', date: 'March 18th, 2003', body: 'Those are Nordics. Different species from the greys. Some people say they are more emotionally available but I have no personal experience with them. Greys will always be my first love.' },
      { username: 'kennethreid17', date: 'March 20th, 2003', body: 'I have read about Nordics online. Supposedly they are more gentle and communicative. Could be worth pursuing if the greys arent responding to you.' },
      { username: 'probemeplease', date: 'April 1st, 2003', body: 'Nordics, greys, reptilians, I dont care what species. I just want to be touched by something extraterrestrial.' },
    ],
  },
  {
    id: 14,
    title: 'Saw the site, had to register immediately',
    username: 'kennethreid17',
    date: 'March 19th, 2004',
    body: 'Found this place completely by accident while searching for abduction stories late at night. I cannot believe there are other people who feel this way. I have been carrying this alone for years. Glad I am not the only one lusting this hard. We need to keep this board alive, there is nowhere else like it on the internet.',
    image: null,
    replies: [
      { username: 'probemeplease', date: 'March 20th, 2004', body: 'Welcome. You are home now. This is the only place on earth where people understand.' },
      { username: 'xxgregkirbahuexx', date: 'March 22nd, 2004', body: 'Welcome Kenneth. Glad you found us.' },
    ],
  },
  {
    id: 15,
    title: 'Is anyone still here? Please respond',
    username: 'probemeplease',
    date: 'August 9th, 2006',
    body: 'I havent seen a new post in a while and Im getting worried this community is dying. Please if anyone is still reading this, say something. I need to know Im not alone in this. The longing has been getting worse and I dont have anywhere else to go. I tried talking to a therapist about it and she looked at me like I was insane. All I said was that I felt a deep connection to non human beings and she started talking about medication. She doesnt understand. None of them do. Only you all do.',
    image: null,
    replies: [
      { username: 'greyedbydemons92', date: 'August 14th, 2006', body: 'Still here. Always here. Dont give up on us or on them.' },
      { username: 'abducteeintraining', date: 'August 20th, 2006', body: 'Im still around. Life got busy but the longing never stops. This community is the only real thing I have. Hang in there.' },
      { username: 'kennethreid17', date: 'September 3rd, 2006', body: 'Still here. Still waiting. We all are I think, though I havent heard from greg in a while.' },
    ],
  },
];

function ForumPage() {
  const [showOfflineMessage, setShowOfflineMessage] = useState(false);
  useEffect(() => {
    if (!showOfflineMessage) return;
    const t = setTimeout(() => setShowOfflineMessage(false), 3000);
    return () => clearTimeout(t);
  }, [showOfflineMessage]);
  return (
    <>
      <hr className="section-hr" />
      <div className="forum-page">
        <div className="forum-board-header">
          <h2 className="forum-board-title">Encounters &amp; Experiences</h2>
          <button
            type="button"
            className="forum-create-btn"
            onClick={() => setShowOfflineMessage(true)}
          >
            Create post
          </button>
        </div>
        <p className="forum-board-desc">Recount your encounters and experiences.</p>
        {showOfflineMessage && (
          <p className="forum-offline-msg">Forum server is offline!</p>
        )}
        <div className="forum-posts">
          {FORUM_POSTS.map((post) => (
            <article key={post.id} className="forum-post">
              <header className="forum-post-header">
                <h3 className="forum-post-title">{post.title}</h3>
                <span className="forum-post-meta">
                  {post.username} · {post.date}
                </span>
              </header>
              <div className="forum-post-body">
                {post.image && (
                  <img src={post.image} alt="" className="forum-post-img" />
                )}
                <p className="forum-post-text">{post.body}</p>
              </div>
              {post.replies && post.replies.length > 0 && (
                <section className="forum-replies">
                  {post.replies.map((reply, i) => (
                    <div key={i} className="forum-reply">
                      <span className="forum-reply-meta">{reply.username} · {reply.date}</span>
                      <p className="forum-reply-text">{reply.body}</p>
                    </div>
                  ))}
                </section>
              )}
            </article>
          ))}
        </div>
      </div>
    </>
  );
}

function AboutPage() {
  return (
    <>
      <hr className="section-hr" />
      <div className="about-page">
        <h2 className="about-name">A Deep Longing For Grey Intimacy</h2>
        <img src={gregKirbahue} alt="Greg Kirbahue" className="about-portrait" />
        <p className="about-text">
          My name is Greg Kirbahue age 24 from a small town in Utah. I am writing now to share my experience and hopefully inform you as to why I created this bastion of grey love.
        </p>
        <p className="about-text">
          It all started 5 years ago, January 15th 1985. I was 19 years old around this time and had always had an interest in what existed deep within our cosmos; however, that  turned to obession when I noticed a pair of brilliant swirling lights hovering above me as I drove my car down the interstate. I pulled over and stepped out of my car to see what they were and as I did I began to feel my feet leave the ground. In a panic I began to writhe and accidentaly caught my pant leg on my car intenna. My pants were ripped off in an instant as I floated up into those brilliant lights. I couldn't help but be excited. I found myself soon blinking awake strapped butt naked to a cold metallic table. Bright surgical lights filled my vision as a tall grey figure with long fingers began to appear, my beautiful lover. He introduced himself as Pebi Loblembiba and slowly began to touch me, softly and sexually. He said he was here just to run a few tests and he would then let me go, at this point I whimpered. I found myself oddly attracted to this creature and began to beg him to let me stay even longer than just that. He seemed shocked but perhaps also turned on- I saw his face begin to blush as he said he would need time to make me a permanent subject. I told him I'd wait for him for as long as it took. It's at this point he began to probe me- needless to say it felt amazing. But the probing didn't last for long, not nearly long enough. I awoke once again this time naked in a field with a large bump on my head and a burning on my asshole, I already missed him. Ever since that day I've waited for his return.
        </p>
        <p className="about-text">
          That now brings me to why I made this website. I wanted to create a safe place for people like me to share our sexual love of greys and enjoy content surrounding grey aliens. I hope that one day we all get to reunite with our alien lovers. If I ever do, the forum will unfortunately be offline as I will be off world with my grey lover.
        </p>
      </div>
    </>
  );
}

const SHOP_ITEMS = [
  { id: 'conceive', name: 'I Want to Conceive', image: publicAsset('t_shirts', 'conceive.png'), price: '21.99', link: 'https://www.redbubble.com/i/t-shirt/I-Want-To-Conceive-by-grebkirbahue/179467805/lrcw' },
  { id: 'greycock', name: 'Insert Grey Cock', image: publicAsset('t_shirts', 'greycock.png'), price: '21.99', link: 'https://www.redbubble.com/i/t-shirt/Insert-Grey-Cock-by-grebkirbahue/179468046/lrcw' },
  { id: 'greyedme', name: 'GREYED.ME', image: publicAsset('t_shirts', 'greyedme.png'), price: '21.99', link: 'https://www.redbubble.com/i/t-shirt/GREYED-ME-by-grebkirbahue/179468031/lrcw' },
  { id: 'i_survived', name: 'I Survived Greyed.me', image: publicAsset('t_shirts', 'I_survived.png'), price: '21.99', link: 'https://www.redbubble.com/i/t-shirt/I-Survived-GREYED-ME-by-grebkirbahue/179468058/lrcw' },
  { id: 'probing_shirt', name: 'Insert Probing Device', image: publicAsset('t_shirts', 'probing_shirt.png'), price: '21.99', link: 'https://www.redbubble.com/i/t-shirt/Insert-Probe-by-grebkirbahue/179468071/lrcw' },
];

function ShopPage() {
  return (
    <>
      <hr className="section-hr" />
      <div className="shop-page">
        <div className="shop-grid">
          {SHOP_ITEMS.map((item) => (
            <a
              key={item.id}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="shop-item"
            >
              <div className="shop-item-img-wrap">
                <img src={item.image} alt={item.name} className="shop-item-img" />
              </div>
              <div className="shop-item-name">{item.name}</div>
              <div className="shop-item-price">${item.price}</div>
            </a>
          ))}
        </div>
      </div>
    </>
  );
}

function AgeGate({ onConfirm, denied, onTryAgain }) {
  return (
    <div className="age-gate" style={{ backgroundImage: `url(${tileBg})` }}>
      <div className="age-gate-box">
        <img src={greyedLogo} className="age-gate-logo" alt="GREYED" />
        <h1 className="age-gate-title">GREYED</h1>
        {!denied ? (
          <>
            <p className="age-gate-text">
              Only adults can enjoy intergalactic love...
            </p>
            <p className="age-gate-question">Are you over the age of 18?</p>
            <div className="age-gate-buttons">
              <button type="button" className="age-gate-btn yes" onClick={onConfirm}>
                Yes
              </button>
              <button type="button" className="age-gate-btn no" onClick={onTryAgain}>
                No
              </button>
            </div>
          </>
        ) : (
          <>
            <p className="age-gate-text age-gate-denied">
              You must be over the age of 18 to enter this site.
            </p>
            <p className="age-gate-text">
              Please come back when the stars and your birthday align.
            </p>
          </>
        )}
      </div>
    </div>
  );
}

function App() {
  const [ageState, setAgeState] = useState('asking');
  const [activeTab, setActiveTab] = useState('about');

  if (ageState !== 'confirmed') {
    return (
      <AgeGate
        denied={ageState === 'denied'}
        onConfirm={() => setAgeState('confirmed')}
        onTryAgain={() => setAgeState('denied')}
      />
    );
  }

  const pageContent = {
    about: <AboutPage />,
    videos: <VideosPage />,
    interesting: <InterestingPage />,
    forum: <ForumPage />,
    shop: <ShopPage />,
  };

  return (
    <div
      className="App"
      style={{ backgroundImage: `url(${tileBg})` }}
    >
      <header className="header-row">
        <img src={greyedLogo} className="header-logo" alt="GREYED" />
        <h1 className="page-title">GREYED</h1>
      </header>

      <nav className="tab-nav">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`tab-link ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <img src={tab.img} alt={tab.label} className="tab-img" />
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </nav>

      {pageContent[activeTab]}
    </div>
  );
}

export default App;
